// extracted by mini-css-extract-plugin
export default {"like-dislike":"C9sELGKW2K8Vg4KP7YMg","vote":"Ei2CAl0gmFlRsK6S2WR4","count":"RUBshu7sV6enyB01w5DM","like":"nfkcg8hqBssBgTSBAoAb","dislike":"wR6bFul4wC5O7s1mxbyB"};